<template>
    <ul>
        <li
            is="MessagesListItem"
            v-for="message in messages"
            :message="message"
            :key="message.id"
        />
    </ul>
</template>

<script>
    import MessagesListItem from '@/components/MessagesListItem.vue';

    export default {
        name: 'MessagesList',
        components: {
            MessagesListItem
        },
        computed: {
            messages () {
                return this.$store.getters.getMessagesByState('yes');
            }
        }
    }
</script>

<style lang="scss" scoped>
    ul {
        margin: 2em 0 0 0;
        padding: 0;
    }
</style>